import React from "react";

function Home() {
  return (
    <>
      <section className="intro-section">
        <div className="intro-content">
          <p className="intro-label">Arecah</p>
          <h1>We build and scale ecommerce brands.</h1>
          <p className="intro-body">
            From product sourcing to Shopify builds and optimisation, we turn
            ideas into revenue-generating online businesses.
          </p>
          <p className="intro-clarifying">
            We work with founders and small brands launching or optimising
            Shopify‑based ecommerce stores.
          </p>
        </div>
      </section>

      <section className="work-section">
        <h2 className="section-title">Arecah — Ecommerce</h2>

        <div className="work-grid">
          <a
            href="https://bigdogthings.com.au"
            target="_blank"
            rel="noopener noreferrer"
            className="work-item work-item-featured"
          >
            <div className="work-image">
              <img src="/images/BigDogThings.png" alt="Big Dog Things" />
            </div>
            <div className="work-info">
              <span className="work-category">Ecommerce · Shopify</span>
              <h3>Big Dog Things</h3>
              <p>
                Premium training gear for large breed dogs. Built and structured
                on Shopify for national shipping.
              </p>
              <span className="work-link">View site</span>
            </div>
          </a>
        </div>
      </section>

      <section className="cta-section">
        <h2 className="cta-headline">
          Have an ecommerce idea or store to improve?
        </h2>
        <p className="cta-subtext">Let's discuss your project.</p>
        <a href="mailto:info@arecah.com" className="cta-button">
          Get in touch
        </a>
      </section>
    </>
  );
}

export default Home;
